import { useSidebarStore } from '../stores/sidebarStore.js'
import { storeToRefs } from 'pinia'
import { useRouter } from 'vue-router'

/**
 * Composable for sidebar navigation functionality
 * Provides common utilities for navigation items
 */
export function useSidebarNavigation() {
  const router = useRouter()
  const sidebarStore = useSidebarStore()

  const { sidebarIsExpanded, screenIsMobile } = storeToRefs(sidebarStore)

  /**
   * Generate a unique ID/key for a navigation item
   * @param {Object} item - Navigation item
   * @returns {string} Unique identifier
   */
  const getItemKey = (item) => {
    return item.name
  }

  /**
   * Handle navigation click - close sidebar on mobile
   */
  const handleMobileNavigation = () => {
    if (sidebarIsExpanded.value && screenIsMobile.value) {
      sidebarStore.toggleExpanded()
    }
  }

  /**
   * Handle submenu expansion
   * @param {Object} item - Navigation item to expand
   */
  const handleSubmenuExpansion = (item) => {
    const redirectPath = sidebarStore.expandSubmenu(item)
    if (redirectPath) {
      router.push(redirectPath)
    }
  }

  /**
   * Default button classes for navigation items
   */
  const defaultButtonClasses =
    'items-center py-2 px-4 font-semibold text-grey-11 dark:text-dark-ink-muted hover:text-grey-11 dark:hover:text-dark-ink-muted hover:bg-grey-13 dark:hover:bg-dark-surface-2 rounded-full active:bg-red-2 active:text-white'

  return {
    // Store refs
    sidebarStore,
    sidebarIsExpanded,
    screenIsMobile,
    
    // Utilities
    getItemKey,
    
    // Actions
    handleMobileNavigation,
    handleSubmenuExpansion,
    
    // Constants
    defaultButtonClasses,
  }
}
